import { render } from "./IconPhelcomEye.vue?vue&type=template&id=6e1a3f35"
import script from "./IconPhelcomEye.vue?vue&type=script&lang=js"
export * from "./IconPhelcomEye.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__